import CONFIG from "@/assets/js/config.custom";

const officeAdmin = CONFIG.ROLE.ID.OFFICE_ADMIN;
const accountant = CONFIG.ROLE.ID.ACCOUNTANT;
const principal = CONFIG.ROLE.ID.PRINCIPAL;
const academicCoordinator = CONFIG.ROLE.ID.ACADEMIC_COORDINATOR;
const libraryAdmin = CONFIG.ROLE.ID.LIBRARY_ADMIN;
const admin = CONFIG.ROLE.ID.ADMIN;
const hrOperator = CONFIG.ROLE.ID.HR_OPERATOR;
const superAdminNo = "0001";
const subjectTeacher = 'subjectTeacher';
const homeRoomTeacher = 'homeRoomTeacher';
const assistantTeacher = 'assistantTeacher';
const newTeacher = 'newTeacher';

const ACCESS_CONTROL = {
  ADMIN: {
    create: [officeAdmin, superAdminNo],
    edit: [officeAdmin, superAdminNo]
  },
  PERIOD: {
    create: [officeAdmin, hrOperator, admin],
    edit: [officeAdmin, hrOperator, admin]
  },
  GRADE: {
    create: [officeAdmin, admin],
    edit: [officeAdmin, admin]
  },
  HOLIDAY: {
    create: [hrOperator, admin],
    edit: [hrOperator, admin],
    delete: [hrOperator, admin],
    downloadCalendar: [subjectTeacher, homeRoomTeacher, assistantTeacher, hrOperator, admin],
    exportExcel: [hrOperator, principal, accountant, admin],
    importExcel: [hrOperator, admin],
    export: [admin, officeAdmin, hrOperator, accountant, principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, newTeacher]
  },
  PAYMENT_METHOD: {
    create: [accountant, hrOperator, admin],
    edit: [accountant, hrOperator, admin],
    delete: [accountant, hrOperator, admin]
  },
  TEACHER_TYPE: {
    create: [principal, academicCoordinator, hrOperator, admin],
    edit: [principal, academicCoordinator, hrOperator, admin],
    delete: [principal, academicCoordinator, hrOperator, admin]
  },
  APP_FORM: {
    create: [officeAdmin, principal, admin],
    edit: [officeAdmin, principal, admin],
    delete: [officeAdmin, principal, admin],
    download: [officeAdmin, principal, admin]
  },
  CAMPUS_GRADE: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin],
    import: [principal, academicCoordinator, admin]
  },
  GRADE_FEE: {
    create: [accountant, admin],
    edit: [accountant, admin],
    delete: [accountant, admin]
  },
  CLASS: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin]
  },
  SUBJECT: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin]
  },
  TIMETABLE_META: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin]
  },
  TIMETABLE: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin],
    exportExcel: [principal, academicCoordinator, admin]
  },
  TEACHER: {
    create: [principal, admin],
    edit: [principal, admin],
    delete: [principal, admin],
    import: [officeAdmin, principal, admin]
  },
  SUBJECT_TEACHER: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin]
  },
  COURSE: {
    create: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
    edit: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
    delete: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin]
  },
  ASSIGNMENT: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin]
  },
  TEACHER_ATTENDANCE: {
    create: [admin, officeAdmin, hrOperator, accountant, principal, academicCoordinator],
    edit: [hrOperator, admin],
    delete: [admin, officeAdmin, hrOperator, accountant, principal, academicCoordinator],
    deleteShiftAssign: [hrOperator],
  },
  TEACHER_LEAVE: {
    create: [admin, officeAdmin, hrOperator, accountant, principal, subjectTeacher, homeRoomTeacher, assistantTeacher, newTeacher],
    edit: [admin, officeAdmin, hrOperator, accountant, principal, subjectTeacher, homeRoomTeacher, assistantTeacher, newTeacher],
    delete: [admin, officeAdmin, hrOperator, accountant, principal, subjectTeacher, homeRoomTeacher, assistantTeacher, newTeacher],
    approve: [hrOperator],
    exportExcel: [hrOperator, principal],
  },
  CHAT_REQUEST: {
    approve: [principal, academicCoordinator, admin],
    reject: [principal, academicCoordinator, admin]
  },
  PARENT: {
    create: [officeAdmin, principal, admin],
    edit: [officeAdmin, principal, admin],
    delete: [officeAdmin, principal, admin],
    import: [officeAdmin, principal, admin]
  },
  STUDENT: {
    create: [officeAdmin, principal, admin],
    edit: [officeAdmin, principal, admin],
    delete: [officeAdmin, principal, admin],
    import: [officeAdmin, principal, admin],
    setResult: [officeAdmin, principal, admin],
    enrollment: [principal, accountant, admin],
    restore: [officeAdmin, principal, admin],
    downloadQR: [officeAdmin, principal, homeRoomTeacher, assistantTeacher, admin],
    excelDownload: [officeAdmin, principal, accountant, admin],
    reportCardDownload: [officeAdmin, principal, admin]
  },
  EXAM: {
    create: [principal, academicCoordinator, admin],
    edit: [principal, academicCoordinator, admin],
    delete: [principal, academicCoordinator, admin]
  },
  GRADING: {
    create: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
    edit: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
    delete: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
    import: [principal, academicCoordinator, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
  },
  CLASS_SCORE_SUMMARY: {
    bulkDisplay: [principal, admin],
  },
  STUDENT_ATTENDANCE: {
    create: [homeRoomTeacher, assistantTeacher, admin],
    edit: [homeRoomTeacher, assistantTeacher, admin],
    delete: [homeRoomTeacher, assistantTeacher, admin]
  },
  STUDENT_MONTHLY_ATTENDANCE: {
    create: [],
    edit: [],
    delete: []
  },
  STUDENT_LEAVE: {
    create: [officeAdmin, principal, homeRoomTeacher, assistantTeacher, admin],
    edit: [officeAdmin, principal, homeRoomTeacher, assistantTeacher, admin],
    delete: [officeAdmin, principal, homeRoomTeacher, assistantTeacher, admin]
  },
  APPLICANT: {
    setResult: [officeAdmin, principal, academicCoordinator, admin]
  },
  ITEM: {
    create: [officeAdmin, accountant, admin],
    edit: [officeAdmin, accountant, admin],
    delete: [officeAdmin, accountant, admin]
  },
  PAYMENT_REQUEST: {
    setResult: [accountant, admin]
  },
  PAYMENT: {
    create: [accountant, principal, admin],
    edit: [accountant, principal, admin],
    delete: [accountant, principal, admin],
    sendNoti: [accountant, principal, admin]
  },
  TRANSACTION: {
    create: [accountant, admin],
    edit: [accountant, admin],
    delete: [accountant, admin]
  },
  TRANSACTION_CATEGORY: {
    create: [accountant, admin],
    edit: [accountant, admin],
    delete: [accountant, admin]
  },
  TEACHER_SALARY: {
    create: [accountant, hrOperator],
    edit: [accountant, hrOperator],
    delete: [accountant, hrOperator]
  },
  DRIVER: {
    create: [officeAdmin, principal, hrOperator, admin],
    edit: [officeAdmin, principal, hrOperator, admin],
    delete: [officeAdmin, principal, hrOperator, admin]
  },
  FERRY: {
    create: [officeAdmin, hrOperator, admin],
    edit: [officeAdmin, hrOperator, admin],
    delete: [officeAdmin, hrOperator, admin]
  },
  FERRY_ZONE: {
    create: [officeAdmin, principal, accountant, admin],
    edit: [officeAdmin, principal, accountant, admin],
    delete: [officeAdmin, principal, accountant, admin]
  },
  ROUTE: {
    create: [officeAdmin, hrOperator, admin],
    edit: [officeAdmin, hrOperator, admin],
    delete: [officeAdmin, hrOperator, admin]
  },
  ROUTE_POINT: {
    create: [officeAdmin, hrOperator, admin],
    edit: [officeAdmin, hrOperator, admin],
    delete: [officeAdmin, hrOperator, admin]
  },
  FERRY_PICKUP: {
    edit: [officeAdmin, hrOperator, admin],
    delete: [officeAdmin, hrOperator, admin]
  },
  DAILY_FERRY: {
    create: [officeAdmin, hrOperator, admin],
    edit: [officeAdmin, hrOperator, admin],
    delete: [officeAdmin, hrOperator, admin]
  },
  CATEGORY: {
    create: [officeAdmin, libraryAdmin, admin],
    edit: [officeAdmin, libraryAdmin, admin],
    delete: [officeAdmin, libraryAdmin, admin],
  },
  BOOK: {
    create: [officeAdmin, libraryAdmin, admin],
    edit: [officeAdmin, libraryAdmin, admin],
    delete: [officeAdmin, libraryAdmin, admin],
    import: [officeAdmin, libraryAdmin, admin]
  },
  LIBRARY_MEMBER: {
    create: [officeAdmin, libraryAdmin, admin],
    edit: [officeAdmin, libraryAdmin, admin],
    delete: [officeAdmin, libraryAdmin, admin]
  },
  CHECKOUT: {
    create: [officeAdmin, libraryAdmin, admin],
    edit: [officeAdmin, libraryAdmin, admin],
    delete: [officeAdmin, libraryAdmin, admin],
    cancel: [officeAdmin, libraryAdmin, admin]
  },
  DAMAGE_LOSSES: {
    create: [officeAdmin, libraryAdmin, admin],
    edit: [officeAdmin, libraryAdmin, admin],
    delete: [officeAdmin, libraryAdmin, admin],
  },
  NOTICE: {
    create: [officeAdmin, principal, admin],
    edit: [officeAdmin, principal, admin],
    delete: [officeAdmin, principal, admin]
  },
  ENROLLMENT_PAYMENT: {
    create: [principal, admin],
    edit: [principal, admin]
  },
  DISCOUNT_TYPE: {
    create: [accountant, hrOperator, admin],
    edit: [accountant, hrOperator, admin],
    delete: [accountant, hrOperator, admin],
  },
  SCORE_SETTING: {
    create: [principal, admin],
    edit: [principal, admin],
    delete: [principal, admin],
  },
  LEAVE_TYPE: {
    create: [accountant, principal, hrOperator, admin],
    edit: [accountant, principal, hrOperator, admin],
    delete: [accountant, principal, hrOperator, admin],
  },
  SHIFT_PATTERN: {
    create: [accountant, principal, hrOperator, admin],
    edit: [accountant, principal, hrOperator, admin],
    delete: [accountant, principal, hrOperator, admin],
  },
  POSITION: {
    create: [accountant, principal, officeAdmin, hrOperator, admin],
    edit: [accountant, principal, officeAdmin, hrOperator, admin],
    delete: [accountant, principal, officeAdmin, hrOperator, admin],
  },
  PAYMENT_ATTRIBUTE: {
    create: [accountant, principal, hrOperator],
    edit: [accountant, principal, hrOperator],
    delete: [accountant, principal, hrOperator],
  },
  PAYSLIP: {
    generate: [accountant, principal, hrOperator],
    approve: [accountant, principal, hrOperator],
    reject: [accountant, principal, hrOperator],
    paid: [accountant, principal, hrOperator],
  },
  SALARY_HISTORY: {
    delete: [accountant, principal, hrOperator],
  },
  LEAVE_BALANCE: {
    reset: [accountant, principal, hrOperator],
    edit: [accountant, principal, hrOperator],
  },
  SKILL: {
    create: [accountant, principal, hrOperator],
    edit: [accountant, principal, hrOperator],
  },
  ATTRIBUTE_DETAIL: {
    create: [accountant, principal, hrOperator],
    edit: [accountant, principal, hrOperator],
    calculate: [accountant, principal, hrOperator],
    generate: [accountant, principal, hrOperator],
    check: [accountant, principal, hrOperator],
  },
  REPORTCARD_GRADING_ITEM: {
    import: [academicCoordinator, principal, homeRoomTeacher, assistantTeacher, admin],
    edit: [academicCoordinator, principal, homeRoomTeacher, assistantTeacher, admin],
    delete: [academicCoordinator, principal, subjectTeacher, homeRoomTeacher, assistantTeacher, admin],
    batchUpdate: [academicCoordinator, principal, homeRoomTeacher, assistantTeacher, admin],
  },
  PAYMENT_HISTORY: {
    create: [principal, accountant, admin],
    edit: [principal, accountant, admin],
    delete: [principal, accountant, admin],
    approve: [principal, accountant, admin],
    reject: [principal, accountant, admin],
    showForm: [principal, accountant, admin],
  },
  EARLY_YEAR_GRADING: {
    edit: [principal, academicCoordinator, homeRoomTeacher, assistantTeacher, admin],
    download: [principal, academicCoordinator, homeRoomTeacher, assistantTeacher, admin],
  },
  REFERRAL_MANAGEMENT: {
    setResult: [academicCoordinator, principal, admin],
  },
  EMPLOYEE: {
    create: [hrOperator],
    edit: [hrOperator],
    delete: [hrOperator],
    import: [hrOperator],
  }
};

export default ACCESS_CONTROL;
